import {createStore, applyMiddleware, compose} from 'redux';
import {routerMiddleware} from 'react-router-redux';
import thunk from 'redux-thunk';
import createHistory from 'history/createBrowserHistory';
import rootReducer from 'reducers';
import jwt from 'data/jwt'

export const history = createHistory();

history.listen((location, action) => {
  window.scrollTo(0, 0);
});

const initialState = {};
const enhancers = [];
const middleware = [ jwt, thunk, routerMiddleware(history)];

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.devToolsExtension;

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension());
  }
}

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);
const store = createStore(rootReducer, initialState, composedEnhancers);

export default store;
export const getState = () => store.getState();



// WEBPACK FOOTER //
// src/store.js